module.exports = __webpack_public_path__ + "static/media/27OCHA2.8587c373.jpg";